import AppForm from "./FormInputs/AppForm";
import InfoForm from "./FormInputs/InfoForm";
import OptionsForm from "./FormInputs/OptionsForm";
import SubscriptionForm from "./FormInputs/SubscriptionForm";
import SubscriptionPlanForm from "./FormInputs/SubscriptionPlanForm";
import TeamForm from "./Organisation/TeamForm";
import EditCompanyForm from "./Organisation/EditCompanyForm";

export default function Modal({ title, type, id, btnTitle, btnStyle, subscription, cmp,onClose, enable, nb }) {

    let componentToRender;
    if (type === 'app') {
        componentToRender = <AppForm title={title} />;
    } else {
        switch (type) {
            case 'info':
                componentToRender = <InfoForm title={title}  nb={nb}/>;
                break;
            case 'options':
                componentToRender = <OptionsForm title={title} nb={nb} />;
                break;
            case 'subscription':
                componentToRender = <SubscriptionForm title={title} subscription={subscription} cmp={cmp}/>;
                break;
            case 'subscriptionPlan':
                componentToRender = <SubscriptionPlanForm title={title} />;
                break;
            case 'team':
                componentToRender = <TeamForm title={title} />;
                break;
            case 'editCompany':
                componentToRender = <EditCompanyForm title={title}/>;
                break;
            default:
                componentToRender = null;
        }
    }
    return (
        <div>
            {btnStyle === "normal" ? <button
                type="button"
                className={enable ? "btn btn-sm btn-outline-netikash w-100" : "btn btn-sm btn-outline-netikash w-100 "}
                data-bs-toggle="modal"
                data-bs-target={"#"+id}
                style={{minWidth: "100px" }}

            >
                {type === "team" ? <i className="bx bx-group me-2"></i> :<i className='bx bx-plus'></i>}
                {btnTitle}
            </button> : <button
                type="button"
                className="btn btn-warning"
                data-bs-toggle="modal"
                data-bs-target={"#"+id}
            >
                {btnTitle}
            </button>}

            <div className="modal fade" id={id} tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-fullscreen" role="document">
                    {componentToRender}
                </div>
            </div>
        </div>
    );
}